import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '../services/api';

interface User {
  id: string;
  name: string;
  email: string;
  role: string;
  onboardingCompleted?: boolean;
}

interface AuthState {
  token: string | null;
  user: User | null;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (name: string, email: string, password: string) => Promise<void>;
  logout: () => void;
  setUser: (user: User) => void;
  setAuth: (token: string, user: User) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isLoading: false,

      setAuth: (token: string, user: User) => {
        set({ token, user });
      },

      login: async (email: string, password: string) => {
        set({ isLoading: true });
        try {
          const data = await api.post<{ token: string; user: User }>('/auth/login', { email, password });
          set({ token: data.token, user: data.user, isLoading: false });
        } catch (err) {
          set({ isLoading: false });
          throw err;
        }
      },

      register: async (name: string, email: string, password: string) => {
        set({ isLoading: true });
        try {
          const data = await api.post<{ token: string; user: User }>('/auth/register', { name, email, password });
          set({ token: data.token, user: data.user, isLoading: false });
        } catch (err) {
          set({ isLoading: false });
          throw err;
        }
      },

      logout: () => {
        set({ token: null, user: null });
      },

      setUser: (user: User) => {
        set({ user });
      },
    }),
    {
      name: 'botboss-auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
);
